import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import Search from './search';
import { Row, Col, Nav } from 'react-bootstrap';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleChangeDataMainPage } from '../../../../redux/actions/pages/main';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';
import { BASE_SITE, MAIN } from '../../../../apis'; 
import axios from "axios";
import * as qs from "querystring";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import Separator from './separator';
import {Navigation, Pagination, EffectFade, Autoplay, Scrollbar, A11y} from 'swiper/modules';
import { LazyLoadImage } from "react-lazy-load-image-component";


const Main = () => {

    const dispatch = useDispatch();

    const { token } = useSelector(state => state.user);
    const { categories, contents, sliders } = useSelector(state => state.main);
    const { isOpen } = useSelector(state => state.bottom_sheet);

    useEffect(() => {
        callApiGetMain();
        // eslint-disable-next-line
    }, [Main]);

    const callApiGetMain = () => {
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'post',
            url: BASE_SITE + MAIN,
            data: qs.stringify({
                platform: 'web',
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': (!!token ? token : '')
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    break;
                case 'ok':
                    dispatch(handleChangeDataMainPage('categories', response.data.categories));
                    dispatch(handleChangeDataMainPage('contents', response.data.contents));
                    dispatch(handleChangeDataMainPage('sliders', response.data.sliders));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
        });

    };


    const cat_swiper = {
        slidesPerView: 5,
        spaceBetween: 0,
        direction:'horizontal',
        className:"mySwiper",
        // nested: true,
        breakpoints: {
            0: {
                slidesPerView: 3,
            },
            340: {
                slidesPerView: 3.4,
            },
            360: {
                slidesPerView: 3.8,
            },
            385: {
                slidesPerView: 4.3,
            },
            400: {
                slidesPerView: 4.7,
            },
            500: {
                slidesPerView: 5.4,
            }
        }
    }

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    const handleCatClick = (e) => {
        if(isOpen) {
            e.preventDefault();
            closeBottomSheet();
        }
    };

    return (
        <>

            <Nav className="navbar fixed-top text-center bg-white px-4" onClick={closeBottomSheet}>
                <div className="w-100">
                    <img src={SitagLogo} width={100} alt="سیتگ" />
                </div>
                
                <Search className="arash" />
            </Nav>

            <div id="segment-main" onClick={closeBottomSheet}>
                <Row>
                    <Col className="cat-header">
                        دسته بندی
                    </Col>
                </Row>
                
                <Row className="mt-2">

                    <div className="w-100">
                        <Swiper {...cat_swiper}>
                            {
                                categories.map((item, key) => {
                                    return (
                                        <SwiperSlide key={key}>
                                            <Col style={{paddingLeft: "0"}} className="main-cat">
                                                <Link to={`../shops/${item.title}/${item.id}`} onClick={handleCatClick}>
                                                    <img src={item.image} alt={item.title} className="" />
                                                    <p className="cat-title mt-2">{item.title}</p>
                                                </Link>
                                            </Col>
                                        </SwiperSlide>
                                    );  
                                })
                            }
                        </Swiper>
                    </div>
                    
                </Row>


                <Row className="mt-2">
                    <Col>
                        <Swiper 
                                modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
                                slidesPerView={1}
                                pagination={{clickable: true}}
                                autoplay={{delay: 2000, disableOnInteraction: false}}
                                loop={true}
                                navigation >
                        {
                            (sliders !== undefined && sliders.length > 0) ?
                                sliders.map((item, key) => {
                                    return (
                                        <SwiperSlide key={key}>
                                            <LazyLoadImage src={item.image} alt={key} className="w-100"
                                                onClick={() => item.link !== '' ? window.open(item.link, '_blank') : null} />
                                        </SwiperSlide>
                                    );
                                })
                            :''
                        }
                        </Swiper>
                    </Col>
                </Row>



                {                

                    contents.map((item, key) => {
                        return(
                            <Separator data={{item}} key={key} />
                        );
                    })
                }
            </div>

        </>
    );
}

export default Main;